import {
  PREVIEW_CONTRACT_UPDATE,
  PREVIEW_CONTRACT_UPDATE_SUCCESS,
  PREVIEW_CONTRACT_UPDATE_FAILURE,
  PREVIEW_CONTRACT_CREATE,
  PREVIEW_CONTRACT_CREATE_SUCCESS,
  PREVIEW_CONTRACT_CREATE_FAILURE,
  GET_CONTRACT_LIST,
  GET_CONTRACT_LIST_SUCCESS,
  GET_CONTRACT_LIST_FAILURE,
  CREATE_CONTRACT_ITEM,
  CREATE_CONTRACT_ITEM_SUCCESS,
  CREATE_CONTRACT_ITEM_FAILURE,
  GET_CONTRACT_STATUS_LIST,
  GET_CONTRACT_STATUS_LIST_SUCCESS,
  GET_CONTRACT_STATUS_LIST_FAILURE,
  GET_SINGLE_CONTRACT_ITEM,
  GET_SINGLE_CONTRACT_ITEM_SUCCESS,
  GET_SINGLE_CONTRACT_ITEM_FAILURE,
  UPDATE_CONTRACT_ITEM,
  UPDATE_CONTRACT_ITEM_SUCCESS,
  UPDATE_CONTRACT_ITEM_FAILURE,
  DELETE_CONTRACT_ITEMS,
  DELETE_CONTRACT_ITEMS_SUCCESS,
  DELETE_CONTRACT_ITEMS_FAILURE,
  SINGLE_CUSTOMER_SEARCH_CONTRACTS,
  SINGLE_CUSTOMER_SEARCH_CONTRACTS_SUCCESS,
  SINGLE_CUSTOMER_SEARCH_CONTRACTS_FAILURE,
  GET_CONTRACT_ITEMS_LIST,
  GET_CONTRACT_ITEMS_LIST_SUCCESS,
  GET_CONTRACT_ITEMS_LIST_FAILURE,
  GET_CONTRACT_ITEMS_STATUS_LIST,
  GET_CONTRACT_ITEMS_STATUS_LIST_SUCCESS,
  GET_CONTRACT_ITEMS_STATUS_LIST_FAILURE,
  GET_CONTRACT_UNIT_FREQUENCY_LIST,
  GET_CONTRACT_UNIT_FREQUENCY_LIST_SUCCESS,
  GET_CONTRACT_UNIT_FREQUENCY_LIST_FAILURE,
  GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST,
  GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUCCESS,
  GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_FAILURE,
  CREATE_CONTRACT_WITH_ITEMS,
  CREATE_CONTRACT_WITH_ITEMS_SUCCESS,
  CREATE_CONTRACT_WITH_ITEMS_FAILURE,
  GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY,
  GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY_SUCCESS,
  GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY_FAILURE,
  UPDATE_CONTRACT_WITH_ITEMS,
  UPDATE_CONTRACT_WITH_ITEMS_SUCCESS,
  UPDATE_CONTRACT_WITH_ITEMS_FAILURE,
  GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST,
  GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST_SUCCESS,
  GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST_FAILURE,
  DELETE_SINGLE_CONTRACT_ITEM,
  DELETE_SINGLE_CONTRACT_ITEM_SUCCESS,
  DELETE_SINGLE_CONTRACT_ITEM_FAILURE,
  GET_CONTRACT_ITEMS_ACTIVE_LIST,
  GET_CONTRACT_ITEMS_ACTIVE_LIST_SUCCESS,
  GET_CONTRACT_ITEMS_ACTIVE_LIST_FAILURE,
  GET_CONTRACT_ITEMS_CANCELLED_LIST,
  GET_CONTRACT_ITEMS_CANCELLED_LIST_SUCCESS,
  GET_CONTRACT_ITEMS_CANCELLED_LIST_FAILURE,
  GET_CONTRACT_ITEM_USAGE_SEARCH_LIST,
  GET_CONTRACT_ITEM_USAGE_SEARCH_LIST_SUCCESS,
  GET_CONTRACT_ITEM_USAGE_SEARCH_LIST_FAILURE,
  GET_CONTRACT_ITEM_USAGE_LIST,
  GET_CONTRACT_ITEM_USAGE_LIST_SUCCESS,
  GET_CONTRACT_ITEM_USAGE_LIST_FAILURE,
  GET_CONTRACT_ITEM_USAGE_SEARCH,
  GET_CONTRACT_ITEM_USAGE_SEARCH_SUCCESS,
  GET_CONTRACT_ITEM_USAGE_SEARCH_FAILURE,
  SEARCH_CONTRACT_PDF,
  SEARCH_CONTRACT_PDF_SUCCESS,
  SEARCH_CONTRACT_PDF_FAILURE,
  DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE,
  DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE_SUCCESS,
  DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE_FAILURE,
  GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF,
  GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF_SUCCESS,
  GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF_FAILURE,
  GENERATE_CONTRACT_ITEM_USAGE,
  GENERATE_CONTRACT_ITEM_USAGE_SUCCESS,
  GENERATE_CONTRACT_ITEM_USAGE_FAILURE,
  GET_CONTRACT_ITEM_USAGE_PDF,
  GET_CONTRACT_ITEM_USAGE_PDF_SUCCESS,
  GET_CONTRACT_ITEM_USAGE_PDF_FAILURE,
  REGENERATE_CONTRACT_ITEM_USAGE_PDF,
  REGENERATE_CONTRACT_ITEM_USAGE_PDF_SUCCESS,
  REGENERATE_CONTRACT_ITEM_USAGE_PDF_FAILURE,
  GET_CONTRACT_ITEM_CREDIT_LIST,
  GET_CONTRACT_ITEM_CREDIT_LIST_SUCCESS,
  GET_CONTRACT_ITEM_CREDIT_LIST_FAILURE,
  CREATE_CONTRACT_ITEM_CREDIT,
  CREATE_CONTRACT_ITEM_CREDIT_SUCCESS,
  CREATE_CONTRACT_ITEM_CREDIT_FAILURE,
  UPDATE_CONTRACT_ITEM_CREDIT,
  UPDATE_CONTRACT_ITEM_CREDIT_SUCCESS,
  UPDATE_CONTRACT_ITEM_CREDIT_FAILURE,
  DELETE_CONTRACT_ITEM_CREDIT,
  DELETE_CONTRACT_ITEM_CREDIT_SUCCESS,
  DELETE_CONTRACT_ITEM_CREDIT_FAILURE,
  GET_CONTRACT_ITEM_PORTFOLIO,
  GET_CONTRACT_ITEM_PORTFOLIO_SUCCESS,
  GET_CONTRACT_ITEM_PORTFOLIO_FAILURE,
  GET_CONTRACT_ITEM_DEBIT_LIST,
  GET_CONTRACT_ITEM_DEBIT_LIST_SUCCESS,
  GET_CONTRACT_ITEM_DEBIT_LIST_FAILURE,
  GET_JOB_LIST_BY_CONTRACT_ITEM,
  GET_JOB_LIST_BY_CONTRACT_ITEM_SUCCESS,
  GET_JOB_LIST_BY_CONTRACT_ITEM_FAILURE,
} from "./actionType";

// Action for getting contract list
export const getContractList = () => {
  return {
    type: GET_CONTRACT_LIST,
  };
};

// Action for getting contract list success

export const getContractListSuccess = (data) => {
  return {
    type: GET_CONTRACT_LIST_SUCCESS,
    payload: data,
  };
};

// Action for getting contract list failure

export const getContractListFailure = (error) => {
  return {
    type: GET_CONTRACT_LIST_FAILURE,
    payload: error,
  };
};

// Action for creating contract item

export const createContractItem = (data) => {
  return {
    type: CREATE_CONTRACT_ITEM,
    payload: data,
  };
};

// Action for creating contract item success

export const createContractItemSuccess = (data) => {
  return {
    type: CREATE_CONTRACT_ITEM_SUCCESS,
    payload: data,
  };
};

// Action for creating contract item failure

export const createContractItemFailure = (error) => {
  return {
    type: CREATE_CONTRACT_ITEM_FAILURE,
    payload: error,
  };
};

// Action for getting contract status list

export const getContractStatusList = () => {
  return {
    type: GET_CONTRACT_STATUS_LIST,
  };
};

// Action for getting contract status list success

export const getContractStatusListSuccess = (data) => {
  return {
    type: GET_CONTRACT_STATUS_LIST_SUCCESS,
    payload: data,
  };
};

// Action for getting contract status list failure

export const getContractStatusListFailure = (error) => {
  return {
    type: GET_CONTRACT_STATUS_LIST_FAILURE,
    payload: error,
  };
};

// Action for getting single contract item

export const getSingleContractItem = (id) => {
  return {
    type: GET_SINGLE_CONTRACT_ITEM,
    payload: id,
  };
};

// Action for getting single contract item success

export const getSingleContractItemSuccess = (data) => {
  return {
    type: GET_SINGLE_CONTRACT_ITEM_SUCCESS,
    payload: data,
  };
};

// Action for getting single contract item failure

export const getSingleContractItemFailure = (error) => {
  return {
    type: GET_SINGLE_CONTRACT_ITEM_FAILURE,
    payload: error,
  };
};

// Action for updating contract item

export const updateContractItem = (data) => {
  return {
    type: UPDATE_CONTRACT_ITEM,
    payload: data,
  };
};

// Action for updating contract item success

export const updateContractItemSuccess = (data) => {
  return {
    type: UPDATE_CONTRACT_ITEM_SUCCESS,
    payload: data,
  };
};

// Action for updating contract item failure

export const updateContractItemFailure = (error) => {
  return {
    type: UPDATE_CONTRACT_ITEM_FAILURE,
    payload: error,
  };
};

// Action for deleting contract items

export const deleteContractItems = (data) => {
  return {
    type: DELETE_CONTRACT_ITEMS,
    payload: data,
  };
};

// Action for deleting contract items success

export const deleteContractItemsSuccess = (data) => {
  return {
    type: DELETE_CONTRACT_ITEMS_SUCCESS,
    payload: data,
  };
};

// Action for deleting contract items failure

export const deleteContractItemsFailure = (error) => {
  return {
    type: DELETE_CONTRACT_ITEMS_FAILURE,
    payload: error,
  };
};

// Action for single customer search contracts

export const singleCustomerSearchContracts = (data) => {
  return {
    type: SINGLE_CUSTOMER_SEARCH_CONTRACTS,
    payload: data,
  };
};

// Action for single customer search contracts success

export const singleCustomerSearchContractsSuccess = (data) => {
  return {
    type: SINGLE_CUSTOMER_SEARCH_CONTRACTS_SUCCESS,
    payload: data,
  };
};

// Action for single customer search contracts failure

export const singleCustomerSearchContractsFailure = (error) => {
  return {
    type: SINGLE_CUSTOMER_SEARCH_CONTRACTS_FAILURE,
    payload: error,
  };
};

// Action for getting contract items list

export const getContractItemsList = () => {
  return {
    type: GET_CONTRACT_ITEMS_LIST,
  };
};

// Action for getting contract items list success

export const getContractItemsListSuccess = (data) => {
  return {
    type: GET_CONTRACT_ITEMS_LIST_SUCCESS,
    payload: data,
  };
};

// Action for getting contract items list failure

export const getContractItemsListFailure = (error) => {
  return {
    type: GET_CONTRACT_ITEMS_LIST_FAILURE,
    payload: error,
  };
};

// Action for getting contract items status list

export const getContractItemsStatusList = () => {
  return {
    type: GET_CONTRACT_ITEMS_STATUS_LIST,
  };
};

// Action for getting contract items status list success

export const getContractItemsStatusListSuccess = (data) => {
  return {
    type: GET_CONTRACT_ITEMS_STATUS_LIST_SUCCESS,
    payload: data,
  };
};

// Action for getting contract items status list failure

export const getContractItemsStatusListFailure = (error) => {
  return {
    type: GET_CONTRACT_ITEMS_STATUS_LIST_FAILURE,
    payload: error,
  };
};

// Action for getting contract unit frequency list

export const getContractUnitFrequencyList = () => {
  return {
    type: GET_CONTRACT_UNIT_FREQUENCY_LIST,
  };
};

// Action for getting contract unit frequency list success

export const getContractUnitFrequencyListSuccess = (data) => {
  return {
    type: GET_CONTRACT_UNIT_FREQUENCY_LIST_SUCCESS,
    payload: data,
  };
};

// Action for getting contract unit frequency list failure

export const getContractUnitFrequencyListFailure = (error) => {
  return {
    type: GET_CONTRACT_UNIT_FREQUENCY_LIST_FAILURE,
    payload: error,
  };
};

//  Single Customer Contract Item List

export const searchSingleCustomerContractItemList = (data) => {
  return {
    type: GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST,
    payload: data,
  };
};

//  Single Customer Contract Item List Success

export const searchSingleCustomerContractItemListSuccess = (data) => {
  return {
    type: GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUCCESS,
    payload: data,
  };
};

//  Single Customer Contract Item List Failure

export const searchSingleCustomerContractItemListFailure = (error) => {
  return {
    type: GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_FAILURE,
    payload: error,
  };
};

// Create Contract With Items

export const createContractWithItems = (data) => {
  return {
    type: CREATE_CONTRACT_WITH_ITEMS,
    payload: data,
  };
};

// Create Contract With Items Success

export const createContractWithItemsSuccess = (data) => {
  return {
    type: CREATE_CONTRACT_WITH_ITEMS_SUCCESS,
    payload: data,
  };
};

// Create Contract With Items Failure

export const createContractWithItemsFailure = (error) => {
  return {
    type: CREATE_CONTRACT_WITH_ITEMS_FAILURE,
    payload: error,
  };
};

// Single Customer Contract Item Summary List

export const searchSingleCustomerContractItemSummaryList = (data) => {
  return {
    type: GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY,
    payload: data,
  };
};

// Single Customer Contract Item Summary List Success

export const searchSingleCustomerContractItemSummaryListSuccess = (data) => {
  return {
    type: GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY_SUCCESS,
    payload: data,
  };
};

// Single Customer Contract Item Summary List Failure

export const searchSingleCustomerContractItemSummaryListFailure = (error) => {
  return {
    type: GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY_FAILURE,
    payload: error,
  };
};

// Update Contract With Items

export const updateContractWithItems = (data) => {
  return {
    type: UPDATE_CONTRACT_WITH_ITEMS,
    payload: data,
  };
};

// Update Contract With Items Success

export const updateContractWithItemsSuccess = (data) => {
  return {
    type: UPDATE_CONTRACT_WITH_ITEMS_SUCCESS,
    payload: data,
  };
};

// Update Contract With Items Failure

export const updateContractWithItemsFailure = (error) => {
  return {
    type: UPDATE_CONTRACT_WITH_ITEMS_FAILURE,
    payload: error,
  };
};

// Preview Contract Update (dry-run)

export const previewContractUpdate = (data) => {
  return {
    type: PREVIEW_CONTRACT_UPDATE,
    payload: data,
  };
};

export const previewContractUpdateSuccess = (data) => {
  return {
    type: PREVIEW_CONTRACT_UPDATE_SUCCESS,
    payload: data,
  };
};

export const previewContractUpdateFailure = (error) => {
  return {
    type: PREVIEW_CONTRACT_UPDATE_FAILURE,
    payload: error,
  };
};

// Preview Contract Create (dry-run)

export const previewContractCreate = (data) => ({
  type: PREVIEW_CONTRACT_CREATE,
  payload: data,
});
export const previewContractCreateSuccess = (data) => ({
  type: PREVIEW_CONTRACT_CREATE_SUCCESS,
  payload: data,
});
export const previewContractCreateFailure = (error) => ({
  type: PREVIEW_CONTRACT_CREATE_FAILURE,
  payload: error,
});

// Get Contract item Renewal Frequency List

export const getContractItemRenewalFrequencyList = () => {
  return {
    type: GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST,
  };
};

// Get Contract item Renewal Frequency List Success

export const getContractItemRenewalFrequencyListSuccess = (data) => {
  return {
    type: GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST_SUCCESS,
    payload: data,
  };
};

// Get Contract item Renewal Frequency List Failure

export const getContractItemRenewalFrequencyListFailure = (error) => {
  return {
    type: GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST_FAILURE,
    payload: error,
  };
};

// Delete Single Contract Item

export const deleteSingleContractItem = (data) => {
  return {
    type: DELETE_SINGLE_CONTRACT_ITEM,
    payload: data,
  };
};

// Delete Single Contract Item Success

export const deleteSingleContractItemSuccess = (data) => {
  return {
    type: DELETE_SINGLE_CONTRACT_ITEM_SUCCESS,
    payload: data,
  };
};

// Delete Single Contract Item Failure

export const deleteSingleContractItemFailure = (error) => {
  return {
    type: DELETE_SINGLE_CONTRACT_ITEM_FAILURE,
    payload: error,
  };
};

// Get Contract Items Active List

export const getContractItemsActiveList = () => {
  return {
    type: GET_CONTRACT_ITEMS_ACTIVE_LIST,
  };
};

// Get Contract Items Active List Success

export const getContractItemsActiveListSuccess = (data) => {
  return {
    type: GET_CONTRACT_ITEMS_ACTIVE_LIST_SUCCESS,
    payload: data,
  };
};

// Get Contract Items Active List Failure

export const getContractItemsActiveListFailure = (error) => {
  return {
    type: GET_CONTRACT_ITEMS_ACTIVE_LIST_FAILURE,
    payload: error,
  };
};

// Get Contract Items Cancelled List

export const getContractItemsCancelledList = () => {
  return {
    type: GET_CONTRACT_ITEMS_CANCELLED_LIST,
  };
};

// Get Contract Items Cancelled List Success

export const getContractItemsCancelledListSuccess = (data) => {
  return {
    type: GET_CONTRACT_ITEMS_CANCELLED_LIST_SUCCESS,
    payload: data,
  };
};

// Get Contract Items Cancelled List Failure

export const getContractItemsCancelledListFailure = (error) => {
  return {
    type: GET_CONTRACT_ITEMS_CANCELLED_LIST_FAILURE,
    payload: error,
  };
};

// Get Contract Item Usage Search List

export const getContractItemUsageSearchList = (data) => {
  return {
    type: GET_CONTRACT_ITEM_USAGE_SEARCH_LIST,
    payload: data,
  };
};

// Get Contract Item Usage Search List Success

export const getContractItemUsageSearchListSuccess = (data) => {
  return {
    type: GET_CONTRACT_ITEM_USAGE_SEARCH_LIST_SUCCESS,
    payload: data,
  };
};

// Get Contract Item Usage Search List Failure

export const getContractItemUsageSearchListFailure = (error) => {
  return {
    type: GET_CONTRACT_ITEM_USAGE_SEARCH_LIST_FAILURE,
    payload: error,
  };
};

// Get Contract Item Usage List

export const getContractItemUsageList = () => {
  return {
    type: GET_CONTRACT_ITEM_USAGE_LIST,
  };
};

// Get Contract Item Usage List Success

export const getContractItemUsageListSuccess = (data) => {
  return {
    type: GET_CONTRACT_ITEM_USAGE_LIST_SUCCESS,
    payload: data,
  };
};

// Get Contract Item Usage List Failure

export const getContractItemUsageListFailure = (error) => {
  return {
    type: GET_CONTRACT_ITEM_USAGE_LIST_FAILURE,
    payload: error,
  };
};

// Get Contract Item Usage Search

export const getContractItemUsageSearch = (data) => {
  return {
    type: GET_CONTRACT_ITEM_USAGE_SEARCH,
    payload: data,
  };
};

// Get Contract Item Usage Search Success

export const getContractItemUsageSearchSuccess = (data) => {
  return {
    type: GET_CONTRACT_ITEM_USAGE_SEARCH_SUCCESS,
    payload: data,
  };
};

// Get Contract Item Usage Search Failure

export const getContractItemUsageSearchFailure = (error) => {
  return {
    type: GET_CONTRACT_ITEM_USAGE_SEARCH_FAILURE,
    payload: error,
  };
};

// Search Contract PDF

export const searchContractPdf = (data) => {
  return {
    type: SEARCH_CONTRACT_PDF,
    payload: data,
  };
};

// Search Contract PDF Success

export const searchContractPdfSuccess = (data) => {
  return {
    type: SEARCH_CONTRACT_PDF_SUCCESS,
    payload: data,
  };
};

// Search Contract PDF Failure

export const searchContractPdfFailure = (error) => {
  return {
    type: SEARCH_CONTRACT_PDF_FAILURE,
    payload: error,
  };
};

// Delete All Previous Contract Item Usage

export const deleteAllPreviousContractItemUsage = (data) => {
  return {
    type: DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE,
    payload: data,
  };
};

// Delete All Previous Contract Item Usage Success

export const deleteAllPreviousContractItemUsageSuccess = (data) => {
  return {
    type: DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE_SUCCESS,
    payload: data,
  };
};

// Delete All Previous Contract Item Usage Failure

export const deleteAllPreviousContractItemUsageFailure = (error) => {
  return {
    type: DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE_FAILURE,
    payload: error,
  };
};

// Get Contract Item Usage Live Balance PDF

export const getContractItemUsageLiveBalancePdf = (data) => {
  return {
    type: GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF,
    payload: data,
  };
};

// Get Contract Item Usage Live Balance PDF Success

export const getContractItemUsageLiveBalancePdfSuccess = (data) => {
  return {
    type: GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF_SUCCESS,
    payload: data,
  };
};

// Get Contract Item Usage Live Balance PDF Failure

export const getContractItemUsageLiveBalancePdfFailure = (error) => {
  return {
    type: GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF_FAILURE,
    payload: error,
  };
};

// Generate Contract Item Usage Statement (on demand)

export const generateContractItemUsage = (data) => {
  return {
    type: GENERATE_CONTRACT_ITEM_USAGE,
    payload: data,
  };
};

export const generateContractItemUsageSuccess = (data) => {
  return {
    type: GENERATE_CONTRACT_ITEM_USAGE_SUCCESS,
    payload: data,
  };
};

export const generateContractItemUsageFailure = (error) => {
  return {
    type: GENERATE_CONTRACT_ITEM_USAGE_FAILURE,
    payload: error,
  };
};

// Get a single Contract Item Usage statement PDF (by ContractItemUsage_Id)

export const getContractItemUsagePdf = (data) => {
  return {
    type: GET_CONTRACT_ITEM_USAGE_PDF,
    payload: data,
  };
};

export const getContractItemUsagePdfSuccess = (data) => {
  return {
    type: GET_CONTRACT_ITEM_USAGE_PDF_SUCCESS,
    payload: data,
  };
};

export const getContractItemUsagePdfFailure = (error) => {
  return {
    type: GET_CONTRACT_ITEM_USAGE_PDF_FAILURE,
    payload: error,
  };
};

// Regenerate a single Contract Item Usage statement PDF (into the new design)

export const regenerateContractItemUsagePdf = (data) => {
  return {
    type: REGENERATE_CONTRACT_ITEM_USAGE_PDF,
    payload: data,
  };
};

export const regenerateContractItemUsagePdfSuccess = (data) => {
  return {
    type: REGENERATE_CONTRACT_ITEM_USAGE_PDF_SUCCESS,
    payload: data,
  };
};

export const regenerateContractItemUsagePdfFailure = (error) => {
  return {
    type: REGENERATE_CONTRACT_ITEM_USAGE_PDF_FAILURE,
    payload: error,
  };
};

// Get Contract Item Credit List (by ContractItem_Id)

export const getContractItemCreditList = (data) => {
  return {
    type: GET_CONTRACT_ITEM_CREDIT_LIST,
    payload: data,
  };
};

export const getContractItemCreditListSuccess = (data) => {
  return {
    type: GET_CONTRACT_ITEM_CREDIT_LIST_SUCCESS,
    payload: data,
  };
};

export const getContractItemCreditListFailure = (error) => {
  return {
    type: GET_CONTRACT_ITEM_CREDIT_LIST_FAILURE,
    payload: error,
  };
};

// Create Contract Item Credit (manual)

export const createContractItemCredit = (data) => {
  return {
    type: CREATE_CONTRACT_ITEM_CREDIT,
    payload: data,
  };
};

export const createContractItemCreditSuccess = (data) => {
  return {
    type: CREATE_CONTRACT_ITEM_CREDIT_SUCCESS,
    payload: data,
  };
};

export const createContractItemCreditFailure = (error) => {
  return {
    type: CREATE_CONTRACT_ITEM_CREDIT_FAILURE,
    payload: error,
  };
};

// Update Contract Item Credit (manual, unallocated only)

export const updateContractItemCredit = (data) => {
  return {
    type: UPDATE_CONTRACT_ITEM_CREDIT,
    payload: data,
  };
};

export const updateContractItemCreditSuccess = (data) => {
  return {
    type: UPDATE_CONTRACT_ITEM_CREDIT_SUCCESS,
    payload: data,
  };
};

export const updateContractItemCreditFailure = (error) => {
  return {
    type: UPDATE_CONTRACT_ITEM_CREDIT_FAILURE,
    payload: error,
  };
};

// Delete Contract Item Credit (manual, unallocated only)

export const deleteContractItemCredit = (data) => {
  return {
    type: DELETE_CONTRACT_ITEM_CREDIT,
    payload: data,
  };
};

export const deleteContractItemCreditSuccess = (data) => {
  return {
    type: DELETE_CONTRACT_ITEM_CREDIT_SUCCESS,
    payload: data,
  };
};

export const deleteContractItemCreditFailure = (error) => {
  return {
    type: DELETE_CONTRACT_ITEM_CREDIT_FAILURE,
    payload: error,
  };
};

// Get Company-wide Time-Tracked Contract Item Portfolio

export const getContractItemPortfolio = (data) => {
  return {
    type: GET_CONTRACT_ITEM_PORTFOLIO,
    payload: data,
  };
};

export const getContractItemPortfolioSuccess = (data) => {
  return {
    type: GET_CONTRACT_ITEM_PORTFOLIO_SUCCESS,
    payload: data,
  };
};

export const getContractItemPortfolioFailure = (error) => {
  return {
    type: GET_CONTRACT_ITEM_PORTFOLIO_FAILURE,
    payload: error,
  };
};

// Get Contract Item Debit List (by ContractItem_Id)

export const getContractItemDebitList = (data) => {
  return {
    type: GET_CONTRACT_ITEM_DEBIT_LIST,
    payload: data,
  };
};

export const getContractItemDebitListSuccess = (data) => {
  return {
    type: GET_CONTRACT_ITEM_DEBIT_LIST_SUCCESS,
    payload: data,
  };
};

export const getContractItemDebitListFailure = (error) => {
  return {
    type: GET_CONTRACT_ITEM_DEBIT_LIST_FAILURE,
    payload: error,
  };
};

// Get Job List By Contract Item (by ContractItem_Id)

export const getJobListByContractItem = (data) => {
  return {
    type: GET_JOB_LIST_BY_CONTRACT_ITEM,
    payload: data,
  };
};

export const getJobListByContractItemSuccess = (data) => {
  return {
    type: GET_JOB_LIST_BY_CONTRACT_ITEM_SUCCESS,
    payload: data,
  };
};

export const getJobListByContractItemFailure = (error) => {
  return {
    type: GET_JOB_LIST_BY_CONTRACT_ITEM_FAILURE,
    payload: error,
  };
};